import { PhasrMonitoredRulesDetailsPanelComponent } from './component/PhasrMonitoredRulesDetailsPanelComponent';
import { WEB_COMPONENT_PHASR_MONITORED_RULES_DETAILS_PANEL } from '../../webcomponents.constants';

export { PhasrMonitoredRulesDetailsPanelComponent };

window.customElements.define(
  WEB_COMPONENT_PHASR_MONITORED_RULES_DETAILS_PANEL,
  PhasrMonitoredRulesDetailsPanelComponent
);
